import { AgentType } from '@/constants';
import React from 'react';
import FormItem from '../FormItem';
import { Control, Controller, FieldErrors, UseFormRegister } from 'react-hook-form';
import { FormValidation } from '@/helpers/formValidations';
import Select from 'react-select';
import { ErrorMessage } from '@hookform/error-message';
import { useGetAllCountries } from '@/hooks/dataProvider';
import { AgentDetailModel } from '@/__generated';
import { useTranslation } from 'react-i18next';

type Props = {
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  control: Control<any, any>;
  profile?: AgentDetailModel | undefined | null;
};

export default function LoginDetailForm({ register, errors, control, profile }: Props) {
  const { t } = useTranslation();

  return (
    <>
      {/* End .col */}
      <div className="col-12 d-flex align-items-center">
        <div style={{ flex: 1, border: '1px dashed #cccccc' }} />
        <div className="fw-bold text-18 text-blue-1  rounded-2 px-10 text-uppercase">{t('LOGIN DETAILS')}</div>
        <div style={{ flex: 1, border: '1px dashed #cccccc' }} />
      </div>

      <div className="col-6">
        <FormItem isRequired errors={errors} label={t('agentRegister_UserName')} name="userName">
          <input disabled={!!profile} type="text" {...register('userName', { ...FormValidation.Required })} autoComplete="username" />
        </FormItem>
      </div>
    </>
  );
}
